const MockTestStyles =({mockTestCard1Object})=>{
    return(<>
    
<style>{`
.carousel-container {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  width: 100%;
}

.carousel-container::-webkit-scrollbar {
  display: none;
}

.carousel-slide {
  flex: 0 0 50px;cursor:pointer;
  scroll-snap-align: start;
  position: relative;
}



.mockTestHeaderFont{
  font-family:${mockTestCard1Object?.titleFonts?.headerFont?.family?.fontFamily};
}

.mockTestTitleFont{
  font-family:${mockTestCard1Object?.titleFonts?.titleFont?.family?.fontFamily};
}
.mockTestSubTitleFont{
  font-family:${mockTestCard1Object?.titleFonts?.subtitleFont?.family?.fontFamily};
}
  .mockTestTagsFont{
  font-family:${mockTestCard1Object?.titleFonts?.tagsFont?.family?.fontFamily};
}
  .mockTestButtonFont{
  font-family:${mockTestCard1Object?.titleFonts?.buttonFont?.family?.fontFamily};
}





















.coloredTextMockV1 {
        animation: background-pan-b24b2865 3s linear infinite;
        animation-duration: 3s;
        animation-timing-function: linear;
        animation-delay: 0s;
        animation-iteration-count: infinite;
        animation-direction: normal;
        animation-fill-mode: none;
        animation-play-state: running;
        animation-name: background-pan-b24b2865;
        animation-timeline: auto;
        animation-range-start: normal;
        animation-range-end: normal;
        background: linear-gradient(to right, #2463eb, #8142e3, #86c2ff, #2463eb);
        -webkit-background-clip: text;
        background-size: 200%;
        -webkit-text-fill-color: transparent;
    }
    @keyframes background-pan-b24b2865 {
        0% {
    background-position: 0;
}
100% {
    background-position: -200%;
}
    }






/* CustomCursor.css */
.buttonQuestionInfoCursor {
    position: fixed;
    width: 0px;
    height: 0px;
    border-radius: 50%;
    background-color: rgba(149, 143, 218, 1); /* Customize color */
    pointer-events: none;
    transform: translate(-50%, -50%);
    
    z-index: 999999999999999 !important;
  }
  .buttonQuestionInfoCursor-text-right, .buttonQuestionInfoCursor-text-left , .buttonQuestionInfoCursor-text-top , .buttonQuestionInfoCursor-text-bottom {
    position: fixed;
     box-shadow:0 7px 20px 0 rgba(1,1,1,0.28);
    border-radius: 10px;
    /* border:2px solid #222; */
    
    pointer-events: none;
    transform: translate(-50%, -50%);
    
   min-height: 190px;border-radius: 5px;
  width:150px;
   
  box-shadow:0 7px 20px 0 rgba(48,25,131,0.091);background: #fff;
    z-index: 999999999999999 !important;
  }
  .buttonQuestionInfoCursor-text-right::after{ content: "";
    position: absolute;
    left: -10px;
    top: 48%;
    margin-left: -6px;
    border-width: 8px;
    border-style: solid;
    border-color:  transparent #ffffff transparent   transparent  ;
}
.buttonQuestionInfoCursor-text-left::after{ content: "";
    position: absolute;
    right: -10px;
    top: 48%;
    margin-right: -6px;
    border-width: 8px;
    border-style: solid;
    border-color:  transparent transparent   transparent  #ffffff  ;
}
   .buttonQuestionInfoCursor-text-top::after{ content: "";
    position: absolute;
    left: 10px;
    top: -15px;
    margin-left: 6px;
    border-width: 8px;
    border-style: solid;
    border-color:  transparent  transparent #ffffff  transparent  ;
} .buttonQuestionInfoCursor-text-bottom::after{ content: "";
    position: absolute;
    left: 10px;
    top: 100%;
    margin-left: 6px;
    margin-bottom: -6px;
    border-width: 8px;
    border-style: solid;
    border-color: #ffffff transparent  transparent   transparent  ;
}
  .buttonQuestionInfoCursor.hovered {
    width: 25px;
    height: 25px;
    background-color: rgba(0, 0, 0, 0.3); /* Customize hover color */
  }
  








.mockTestTopBarV1{
display:grid;grid-template-columns:auto 42%  12% 12% 4% 25%;

}
.mockQueHintClass{
  width: 50px;height: 50px;z-index: 1 !important;
  border-radius:50%;font-weight:900;
  position: absolute;left:40% ;bottom: 10px;
  display: flex;justify-content: center;align-items: center;
}
.queButtonInfoOuter{
  position: relative;
}

.queButtonInfoOuter .queButtonInfoInnerLeft {
   position: absolute !important;top: 10px;left: 295px;min-height: 190px;border-radius: 5px;
  width:150px;
  box-shadow:0 7px 20px 0 rgba(48,25,131,0.041);background: #fff;visibility: hidden;transition:  .5s;
}

.queButtonInfoOuter:hover .queButtonInfoInnerLeft { visibility: visible;transition:  .5s;left:160px;z-index: 999999999999 !important;}
.queButtonInfoInnerLeft::after{ content: "";
    position: absolute;
    left: -10px;
    top: 10px;
    margin-left: -6px;
    border-width: 8px;
    border-style: solid;
    border-color:  transparent #222 transparent   transparent  ;
}


.queButtonInfoOuter .queButtonInfoInnerTop{ 
    position: absolute !important;top: 0px;left: 0px;min-height: 190px;border-radius: 5px;
  width:150px;
  box-shadow:0 7px 20px 0 rgba(48,25,131,0.041);background: #fff;visibility: hidden;transition:  .5s;
 
}.queButtonInfoOuter:hover .queButtonInfoInnerTop{
  visibility: visible;transition:  .5s;top:60px;z-index: 999999999999 !important;
}
.mockQueHintClassTwo{
  width: 35px;height: 35px;z-index: 1 !important;
  border-radius:50%;
  z-index: 11 !important;
  display: flex;justify-content: center !important;align-items: center !important;
}
 .showXsOnlyForMock{display: none ;}
.instructionQPOuterGridT1{display:grid;grid-template-columns: 50% 50%; position: absolute;
  z-index: 9999999999 !important;
  ;left: 0px;right: 0px;bottom: 10px;}
.ellipsisTitleQuiz {
          white-space: nowrap;width:140px;
    overflow: hidden;
    text-overflow: ellipsis;
    }
    .ellipsisTitleQuizTwoRows {
        overflow: hidden;text-align: left;
        display: -webkit-box;
        -webkit-line-clamp: 2;font-size: large;
        -webkit-box-orient: vertical;
        height:26px;color:#222 !important;font-weight:bold  !important;
    } .ellipsisTitleQuizButtonTwoRows {
        overflow: hidden;text-align: left;
        display: -webkit-box;
        -webkit-line-clamp: 2;font-size: large;
        -webkit-box-orient: vertical;
        height:40px;color:#222 !important;font-weight:bold  !important;
    }
.quizSectionGridClass{
  display:grid;
 grid-template-columns:60% 40%; ;
}

    .quizSectionAll{width: 170px;height:40px;font-weight: 900;position: relative;
        box-shadow:0 7px 20px 0 rgba(48,25,131,0.041);display: flex;justify-content: center;align-items: center;
        background:${mockTestCard1Object?.sectionAll?.bgColor?.color};
border: ${mockTestCard1Object?.sectionAll?.border?.borderWidth?.value+mockTestCard1Object?.sectionAll?.border?.borderWidth?.resolution} ${mockTestCard1Object?.sectionAll?.border?.borderType}  ${mockTestCard1Object?.sectionAll?.border?.borderColor?.color};
 border-top-left-radius:${mockTestCard1Object?.sectionAll?.borderRadius?.topLeft?.value}${mockTestCard1Object?.sectionAll?.borderRadius?.topLeft?.resolution};
              border-top-right-radius:${mockTestCard1Object?.sectionAll?.borderRadius?.topRight?.value}${mockTestCard1Object?.sectionAll?.borderRadius?.topRight?.resolution};
              border-bottom-left-radius:${mockTestCard1Object?.sectionAll?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.sectionAll?.borderRadius?.bottomLeft?.resolution};
              border-bottom-right-radius:${mockTestCard1Object?.sectionAll?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.sectionAll?.borderRadius?.bottomRight?.resolution};
}
.quizSectionAllMore{width: 170px;
height:40px;font-weight: 900;position: relative;
        box-shadow:0 7px 20px 0 rgba(48,25,131,0.041);
         background:${mockTestCard1Object?.sectionAll?.bgColor?.color};
border: ${mockTestCard1Object?.sectionAll?.border?.borderWidth?.value+mockTestCard1Object?.sectionAll?.border?.borderWidth?.resolution} ${mockTestCard1Object?.sectionAll?.border?.borderType}  ${mockTestCard1Object?.sectionAll?.border?.borderColor?.color};
 border-top-left-radius:${mockTestCard1Object?.sectionAll?.borderRadius?.topLeft?.value}${mockTestCard1Object?.sectionAll?.borderRadius?.topLeft?.resolution};
              border-top-right-radius:${mockTestCard1Object?.sectionAll?.borderRadius?.topRight?.value}${mockTestCard1Object?.sectionAll?.borderRadius?.topRight?.resolution};
              border-bottom-left-radius:${mockTestCard1Object?.sectionAll?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.sectionAll?.borderRadius?.bottomLeft?.resolution};
              border-bottom-right-radius:${mockTestCard1Object?.sectionAll?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.sectionAll?.borderRadius?.bottomRight?.resolution};
display: flex;justify-content: center;align-items: center;}
.quizSectionAllMore .quizSectionAllInnMore{position: absolute !important;top: 60px;left:0px;right: 0px;height: 390px;border-radius: 5px;
  box-shadow:0 7px 20px 0 rgba(48,25,131,0.041);   background:${mockTestCard1Object?.sectionAllInner?.bgColor?.color};

 border-top-left-radius:${mockTestCard1Object?.sectionAllInner?.borderRadius?.topLeft?.value}${mockTestCard1Object?.sectionAllInner?.borderRadius?.topLeft?.resolution};
              border-top-right-radius:${mockTestCard1Object?.sectionAllInner?.borderRadius?.topRight?.value}${mockTestCard1Object?.sectionAllInner?.borderRadius?.topRight?.resolution};
              border-bottom-left-radius:${mockTestCard1Object?.sectionAllInner?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.sectionAllInner?.borderRadius?.bottomLeft?.resolution};
              border-bottom-right-radius:${mockTestCard1Object?.sectionAllInner?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.sectionAllInner?.borderRadius?.bottomRight?.resolution};
visibility: hidden;transition:  .5s;}
.quizSectionAllMore:hover .quizSectionAllInnMore{visibility: visible;transition:  .5s;top: 45px;z-index: 999999999999 !important;}
 .quizSectionMoreItem {width: 150px;border-radius: 5px;margin-top: 5px;height:40px;font-weight: 900;position: relative;margin-left: 10px;
        box-shadow:0 7px 20px 0 rgba(48,25,131,0.041); background:${mockTestCard1Object?.sectionAll?.bgColor?.color};
border: ${mockTestCard1Object?.sectionAll?.border?.borderWidth?.value+mockTestCard1Object?.sectionAll?.border?.borderWidth?.resolution} ${mockTestCard1Object?.sectionAll?.border?.borderType}  ${mockTestCard1Object?.sectionAll?.border?.borderColor?.color};
 border-top-left-radius:${mockTestCard1Object?.sectionAll?.borderRadius?.topLeft?.value}${mockTestCard1Object?.sectionAll?.borderRadius?.topLeft?.resolution};
              border-top-right-radius:${mockTestCard1Object?.sectionAll?.borderRadius?.topRight?.value}${mockTestCard1Object?.sectionAll?.borderRadius?.topRight?.resolution};
              border-bottom-left-radius:${mockTestCard1Object?.sectionAll?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.sectionAll?.borderRadius?.bottomLeft?.resolution};
              border-bottom-right-radius:${mockTestCard1Object?.sectionAll?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.sectionAll?.borderRadius?.bottomRight?.resolution};
;display: flex;justify-content: center;align-items: center;}
.optionClassOuter{background:${mockTestCard1Object?.optionBoxCard?.bgColor?.color};
border: ${mockTestCard1Object?.optionBoxCard?.border?.borderWidth?.value+mockTestCard1Object?.optionBoxCard?.border?.borderWidth?.resolution} ${mockTestCard1Object?.optionBoxCard?.border?.borderType}  ${mockTestCard1Object?.optionBoxCard?.border?.borderColor?.color};
 border-top-left-radius:${mockTestCard1Object?.optionBoxCard?.borderRadius?.topLeft?.value}${mockTestCard1Object?.optionBoxCard?.borderRadius?.topLeft?.resolution};
              border-top-right-radius:${mockTestCard1Object?.optionBoxCard?.borderRadius?.topRight?.value}${mockTestCard1Object?.optionBoxCard?.borderRadius?.topRight?.resolution};
              border-bottom-left-radius:${mockTestCard1Object?.optionBoxCard?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.optionBoxCard?.borderRadius?.bottomLeft?.resolution};
              border-bottom-right-radius:${mockTestCard1Object?.optionBoxCard?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.optionBoxCard?.borderRadius?.bottomRight?.resolution};
}
.quizSectionMoreItem .quizSectionMoreItemInn{position: absolute;top: 0px;left: 190px;
    width:  170px;height: 230px;border-radius: 5px;
  box-shadow:0 7px 20px 0 rgba(48,25,131,0.041);  background:${mockTestCard1Object?.sectionAllInner?.bgColor?.color};
border: ${mockTestCard1Object?.sectionAllInner?.border?.borderWidth?.value+mockTestCard1Object?.sectionAllInner?.border?.borderWidth?.resolution} ${mockTestCard1Object?.sectionAllInner?.border?.borderType}  ${mockTestCard1Object?.sectionAllInner?.border?.borderColor?.color};
 border-top-left-radius:${mockTestCard1Object?.sectionAllInner?.borderRadius?.topLeft?.value}${mockTestCard1Object?.sectionAllInner?.borderRadius?.topLeft?.resolution};
              border-top-right-radius:${mockTestCard1Object?.sectionAllInner?.borderRadius?.topRight?.value}${mockTestCard1Object?.sectionAllInner?.borderRadius?.topRight?.resolution};
              border-bottom-left-radius:${mockTestCard1Object?.sectionAllInner?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.sectionAllInner?.borderRadius?.bottomLeft?.resolution};
              border-bottom-right-radius:${mockTestCard1Object?.sectionAllInner?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.sectionAllInner?.borderRadius?.bottomRight?.resolution};
;visibility: hidden;transition:  .05s;}
 .quizSectionMoreItem:hover .quizSectionMoreItemInn{visibility: visible;transition:  .5s;top: 0px;left: 170px;}
 
 .quizSectionMoreItemInn::after{ content: "";
    position: absolute;
    left: -10px;
    top: 10px;
    margin-left: -6px;
    border-width: 8px;
    border-style: solid;
    border-color:  transparent ${mockTestCard1Object?.sectionAllInner?.border?.borderColor?.color} transparent   transparent  ;
}
.quizSectionAllMore{width: 170px;
}
.quizSectionAllInn::after{ content: "";
    position: absolute;
    left: 45%;
    top: -16px;
    margin-left: -6px;
    border-width: 8px;
    border-style: solid;
    border-color:  transparent transparent ${mockTestCard1Object?.sectionAllInner?.border?.borderColor?.color}    transparent  ;
}
 .quizSectionAll .quizSectionAllInn{position: absolute;top: 70px;left:0px;right: 0px;border-radius: 5px;
  box-shadow:0 7px 20px 0 rgba(48,25,131,0.041);background:${mockTestCard1Object?.sectionAllInner?.bgColor?.color};
border: ${mockTestCard1Object?.sectionAllInner?.border?.borderWidth?.value+mockTestCard1Object?.sectionAllInner?.border?.borderWidth?.resolution} ${mockTestCard1Object?.sectionAllInner?.border?.borderType}  ${mockTestCard1Object?.sectionAllInner?.border?.borderColor?.color};
 border-top-left-radius:${mockTestCard1Object?.sectionAllInner?.borderRadius?.topLeft?.value}${mockTestCard1Object?.sectionAllInner?.borderRadius?.topLeft?.resolution};
              border-top-right-radius:${mockTestCard1Object?.sectionAllInner?.borderRadius?.topRight?.value}${mockTestCard1Object?.sectionAllInner?.borderRadius?.topRight?.resolution};
              border-bottom-left-radius:${mockTestCard1Object?.sectionAllInner?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.sectionAllInner?.borderRadius?.bottomLeft?.resolution};
              border-bottom-right-radius:${mockTestCard1Object?.sectionAllInner?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.sectionAllInner?.borderRadius?.bottomRight?.resolution};
;visibility: hidden;transition:  .5s;}
 .quizSectionAll:hover .quizSectionAllInn{visibility: visible;transition:  .5s;top: 50px;}
        .MockBottomOuter{display:grid;grid-template-columns:37% 37% 24%;gap:1%;align-items: center;padding-top: 10px;}
.MockBottomInnerLeft{display: flex;justify-content: left;align-items: left;gap:5px}
.MockBottomInnerRight{display: flex;justify-content: right;align-items: right;gap:5px}
.MockBottomInnerRightSubmit{display: flex;justify-content: right;align-items: right;gap:5px}
.MockButtonBorder{ display: flex;justify-content: center;align-items: center;font-size: 14px;height:35px;width:150px;border-radius: 5px;}
.MockButtonNext{font-weight: 700; display: flex;justify-content: center;align-items: center;font-size: 14px;height:35px;width:150px;border-radius: 5px}
.MockButtonSubmit{ font-weight: 900;display: flex;justify-content: center;align-items: center;font-size: 14px;height:35px;width:100%;border-radius: 5px}
 .TestInterfaceLeft{position:fixed;
        border:10px solid  rgba(144, 202, 249,0.11) ;
       left:0%;
        right:75%;bottom:60px;
        background: linear-gradient(to right, #fff,#f5f5f5, #fff, #fff);
        top:60px;
        padding:0px;box-shadow:0 7px 20px 0 rgba(48,25,131,0.041);
        z-index:9999;
       }
        .TestInterfaceRight{position:fixed;
        border:10px solid  rgba(144, 202, 249,0.11) ;
       right:0%;
        left:75%;bottom:60px;
        background: linear-gradient(to right, #fff,#f5f5f5, #fff, #fff);
        top:60px;box-shadow:0 7px 20px 0 rgba(48,25,131,0.041);
        padding:0px;
        z-index:9999;
       }
       .TestInterfaceBottom{position:fixed;
        box-shadow:0 7px 20px 0 rgba(48,25,131,0.091);
       left:0%;
        right:0%;bottom:0px;height:60px;
       
        padding:5px;
        z-index:999999;
       }
       .TestInterfaceTopPagenationT1{position:fixed;
       
       left:0%;
        right:0%;top:60px;height:50px;
       
        padding:0px;
        z-index:99999;
       }.TestInterfaceBottomPagenationT1{position:fixed;
        
       left:0%;
        right:0%;bottom:75px;height:50px;
       
        padding:0px;
        z-index:99999;
       }
    .palletMockTopV1{font-weight: 900;display: flex;justify-content: left;align-items: center;
       height:45px;border-radius: 5px;padding: 5px;background: #fff;}
.palletMockTopV1Title{font-weight: 900;display: flex;justify-content: left;align-items: center;
       height:35px;border-radius: 5px;padding: 5px;}
       .palletMockTopV1PalletBox{display:grid;grid-template-columns:auto 23% 23%;margin-top: 5px;
       height:50px;border-radius: 5px;padding: 0px;}
        .QPMockPalletInfo{ 
        display:grid;grid-template-columns:20% 15% 15% 15% 17% 18% ;margin-top: 5px;
      border-radius: 5px;padding: 5px;
       }
       .palletMockTopV1PalletInfo{
        display:grid;grid-template-columns:33% 33% 33%;margin-top: 5px;
       height:40px;border-radius: 5px;padding-top: 5px;
       }.palletMockTopV1PalletInfoTwo{
        display:grid;grid-template-columns:50% 50%;margin-top: 5px;
       height:40px;border-radius: 5px;padding-top: 5px;
       }
       .palletInfoBtn{background: #fff;margin: 2px; border-radius:5px;height:30px ;display:flex;justify-content:left;align-Items:center;}
.palletAnswered{cursor:pointer;width:25px;height:25px;font-size:12px;background: #222;color:#fff;border-radius:5px;margin:5px;display:flex;justify-content:center;align-Items:center;}
    

.palletInfoTitle{font-weight: 999;font-size: 12px;padding: 5px; }

       .palletGridList{display:flex;justify-content:center;gap:5px;margin:5px;border-radius:5px;cursor: pointer;
            align-items:center;height:40px;}
          .palletGridListTitle{display:flex;justify-content:left;align-Items:center;height:50px;padding-left:15px;font-size:14px;
            font-weight:999;}

            .palletAllButtonsBoxOuter{  position: absolute;left: 0px;right: 0px;bottom: 50px;top:260px;overflow-y: auto;overflow-x: hidden;}
  .palletAllButtonsBox{   display:grid;grid-template-columns:19% 19% 19% 19% 19% ;margin-top: 5px;
       border-radius: 5px;padding-top: 5px;align-items: center ;gap: 5px;padding: 10px;}

       .palletAllButtonsBoxList{display:flex;justify-content: left ;margin-top: 0px;
       border-radius: 5px;padding-top: 5px;align-items: center ;gap: 5px;padding: 10px}
       .palletAllButtonsBoxListQP{display:flex;justify-content: left ;margin-top: 0px;
       border-radius: 5px;padding-top: 5px;align-items: center ;gap: 5px;padding: 10px}
       .palletAttempdedButton{cursor:pointer;position: relative;width: 40px;height: 40px;font-weight: 900; border-top-left-radius:${mockTestCard1Object?.answeredBtn?.borderRadius?.topLeft?.value}${mockTestCard1Object?.answeredBtn?.borderRadius?.topLeft?.resolution};
              border-top-right-radius:${mockTestCard1Object?.answeredBtn?.borderRadius?.topRight?.value}${mockTestCard1Object?.answeredBtn?.borderRadius?.topRight?.resolution};
              border-bottom-left-radius:${mockTestCard1Object?.answeredBtn?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.answeredBtn?.borderRadius?.bottomLeft?.resolution};
              border-bottom-right-radius:${mockTestCard1Object?.answeredBtn?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.answeredBtn?.borderRadius?.bottomRight?.resolution};
box-shadow:0 7px 20px 0 rgba(48,25,131,0.051);margin: 5px;display:flex;justify-content:center;align-Items:center;
                background:${mockTestCard1Object?.answeredBtn?.bgColor?.color};
border: ${mockTestCard1Object?.answeredBtn?.border?.borderWidth?.value+mockTestCard1Object?.answeredBtn?.border?.borderWidth?.resolution} ${mockTestCard1Object?.answeredBtn?.border?.borderType}  ${mockTestCard1Object?.answeredBtn?.border?.borderColor?.color};
 }
 .palletAttempdedButtonQP{padding-left:10px;cursor:pointer;position: relative;width: 130px;height: 40px;font-weight: 900; border-radius: 5px;margin: 5px;display:flex;justify-content:space-between;
 
                background:${mockTestCard1Object?.answeredBtn?.bgColor?.color};
border: ${mockTestCard1Object?.answeredBtn?.border?.borderWidth?.value+mockTestCard1Object?.answeredBtn?.border?.borderWidth?.resolution} ${mockTestCard1Object?.answeredBtn?.border?.borderType}  ${mockTestCard1Object?.answeredBtn?.border?.borderColor?.color};
 }
 .palletAttempdedButtonSmall{cursor:pointer;position: relative;width: 25px;height: 25px;font-weight: 900; border-top-left-radius:${mockTestCard1Object?.answeredBtn?.borderRadius?.topLeft?.value}${mockTestCard1Object?.answeredBtn?.borderRadius?.topLeft?.resolution};
              border-top-right-radius:${mockTestCard1Object?.answeredBtn?.borderRadius?.topRight?.value}${mockTestCard1Object?.answeredBtn?.borderRadius?.topRight?.resolution};
              border-bottom-left-radius:${mockTestCard1Object?.answeredBtn?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.answeredBtn?.borderRadius?.bottomLeft?.resolution};
              border-bottom-right-radius:${mockTestCard1Object?.answeredBtn?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.answeredBtn?.borderRadius?.bottomRight?.resolution};
box-shadow:0 7px 20px 0 rgba(48,25,131,0.051);margin: 5px;font-size:10px;display:flex;justify-content:center;align-Items:center;
    background:${mockTestCard1Object?.answeredBtn?.bgColor?.color};
border: ${mockTestCard1Object?.answeredBtn?.border?.borderWidth?.value+mockTestCard1Object?.answeredBtn?.border?.borderWidth?.resolution} ${mockTestCard1Object?.answeredBtn?.border?.borderType}  ${mockTestCard1Object?.answeredBtn?.border?.borderColor?.color};
 }
  .palletNotAttempdedButton{cursor:pointer;position: relative;width: 40px;height: 40px;font-weight: 900;box-shadow:0 7px 20px 0 rgba(48,25,131,0.051);margin:5px;display:flex;justify-content:center;align-Items:center;
      background:${mockTestCard1Object?.notVisitedBtn?.bgColor?.color};
border: ${mockTestCard1Object?.notVisitedBtn?.border?.borderWidth?.value+mockTestCard1Object?.notVisitedBtn?.border?.borderWidth?.resolution} ${mockTestCard1Object?.notVisitedBtn?.border?.borderType}  ${mockTestCard1Object?.notVisitedBtn?.border?.borderColor?.color};
 border-top-left-radius:${mockTestCard1Object?.notVisitedBtn?.borderRadius?.topLeft?.value}${mockTestCard1Object?.notVisitedBtn?.borderRadius?.topLeft?.resolution};
              border-top-right-radius:${mockTestCard1Object?.notVisitedBtn?.borderRadius?.topRight?.value}${mockTestCard1Object?.notVisitedBtn?.borderRadius?.topRight?.resolution};
              border-bottom-left-radius:${mockTestCard1Object?.notVisitedBtn?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.notVisitedBtn?.borderRadius?.bottomLeft?.resolution};
              border-bottom-right-radius:${mockTestCard1Object?.notVisitedBtn?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.notVisitedBtn?.borderRadius?.bottomRight?.resolution};
}
 .palletNotAttempdedButtonQP{padding-left:10px;cursor:pointer;position: relative;width: 120px;height: 40px;font-weight: 900; ;margin:5px;display:flex;justify-content:space-between;align-Items:center;
     background:${mockTestCard1Object?.notVisitedBtn?.bgColor?.color};
border: ${mockTestCard1Object?.notVisitedBtn?.border?.borderWidth?.value+mockTestCard1Object?.notVisitedBtn?.border?.borderWidth?.resolution} ${mockTestCard1Object?.notVisitedBtn?.border?.borderType}  ${mockTestCard1Object?.notVisitedBtn?.border?.borderColor?.color};
 border-top-left-radius:${mockTestCard1Object?.notVisitedBtn?.borderRadius?.topLeft?.value}${mockTestCard1Object?.notVisitedBtn?.borderRadius?.topLeft?.resolution};
              border-top-right-radius:${mockTestCard1Object?.notVisitedBtn?.borderRadius?.topRight?.value}${mockTestCard1Object?.notVisitedBtn?.borderRadius?.topRight?.resolution};
              border-bottom-left-radius:${mockTestCard1Object?.notVisitedBtn?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.notVisitedBtn?.borderRadius?.bottomLeft?.resolution};
              border-bottom-right-radius:${mockTestCard1Object?.notVisitedBtn?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.notVisitedBtn?.borderRadius?.bottomRight?.resolution};
}
 .palletNotAttempdedButtonSmall{cursor:pointer;position: relative;width: 25px;height: 25px;font-weight: 900; box-shadow:0 7px 20px 0 rgba(48,25,131,0.051);margin: 5px;font-size:10px;display:flex;justify-content:center;align-Items:center;
     background:${mockTestCard1Object?.notVisitedBtn?.bgColor?.color};
border: ${mockTestCard1Object?.notVisitedBtn?.border?.borderWidth?.value+mockTestCard1Object?.notVisitedBtn?.border?.borderWidth?.resolution} ${mockTestCard1Object?.notVisitedBtn?.border?.borderType}  ${mockTestCard1Object?.notVisitedBtn?.border?.borderColor?.color};
 border-top-left-radius:${mockTestCard1Object?.notVisitedBtn?.borderRadius?.topLeft?.value}${mockTestCard1Object?.notVisitedBtn?.borderRadius?.topLeft?.resolution};
              border-top-right-radius:${mockTestCard1Object?.notVisitedBtn?.borderRadius?.topRight?.value}${mockTestCard1Object?.notVisitedBtn?.borderRadius?.topRight?.resolution};
              border-bottom-left-radius:${mockTestCard1Object?.notVisitedBtn?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.notVisitedBtn?.borderRadius?.bottomLeft?.resolution};
              border-bottom-right-radius:${mockTestCard1Object?.notVisitedBtn?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.notVisitedBtn?.borderRadius?.bottomRight?.resolution};
}

  .palletAttempdedButtonInnSmall{ position: absolute;
    top: -3px;
    right: -3px;width: 6px ;height: 6px;
    margin-left: -6px;border-width: 2px;border-radius: 50%;
    border-style: solid;
       border-color:  ${mockTestCard1Object?.answeredBtn?.border?.borderWidth?.value?mockTestCard1Object?.answeredBtn?.border.borderColor?.color:"#222222"}  ;background:${mockTestCard1Object?.markedBtn?.bgColor?.color};
 background:${mockTestCard1Object?.markedBtn?.bgColor?.color};
}
    .palletAttempdedButtonInn{ position: absolute;
    top: -4px;
     right: -4px;width: 8px ;height: 8px;
    margin-left: -6px; border-radius: 50%; border-width: 3px;border-radius: 50%;
    border-style: solid;
    border-color:  ${mockTestCard1Object?.answeredBtn?.border?.borderWidth?.value?mockTestCard1Object?.answeredBtn?.border.borderColor?.color:"#fff"}  ;background:${mockTestCard1Object?.markedBtn?.bgColor?.color};
}
  .palletNotAttempdedButtonInn{ position: absolute;
    top: -5px !important;
    right: -4px;width: 8px ;height: 8px;
    margin-left: -6px; border-radius: 50%; border-width: 3px;border-radius: 50%;
    border-style: solid;
    border-color:  ${mockTestCard1Object?.notAnsweredBtn?.border?.borderWidth?.value?mockTestCard1Object?.notAnsweredBtn?.border.borderColor?.color:"#fff"}  ;
      background:${mockTestCard1Object?.notAnsweredBtn?.bgColor?.color};
}
   .palletAttempdedButtonInnQP{ position: absolute;
    top: -2px;
    right: -2px;width: 8px ;height: 8px;
    margin-left: -6px; border-radius: 50%; border-width: 3px;border-radius: 50%;
    border-style: solid;
    border-color:  ${mockTestCard1Object?.answeredBtn?.border?.borderWidth?.value?mockTestCard1Object?.answeredBtn?.border.borderColor?.color:"#fff"}  ;background:${mockTestCard1Object?.answeredBtn?.bgColor?.color};
}
  .palletNotAttempdedButtonInnQP{ position: absolute;
    top: -4px;
    left: 127px;width: 8px ;height: 8px;
    margin-left: -6px; border-radius: 50%; border-width: 3px;border-radius: 50%;
    border-style: solid;
    border-color:  ${mockTestCard1Object?.answeredBtn?.border?.borderWidth?.value?mockTestCard1Object?.answeredBtn?.border.borderColor?.color:"#fff"}   ;
      background:${mockTestCard1Object?.answeredBtn?.bgColor?.color};
}
  

body{overflow-x:hidden !important}
       /* md */
@media (min-width: 992px) and (max-width: 1199px) {

  .mockQueHintClass{
  bottom: 70px !important;left: 45% !important;
}
   .quizSectionGridClass{
  display:grid;
  grid-template-columns:50% 50%;
}
    .hideMdForMock{display: none !important;} 
    
    .mockTestTopBarV1{
display:grid;grid-template-columns:auto 15% 15% 5%  35%;
}
    .TestInterfaceLeft{
       left:0%;
        right:65%;
       }.TestInterfaceRight{
       right:0%;
        left:65%;
       }}

  /* sm */
@media (min-width: 768px) and (max-width: 991px) {
    .mockQueHintClass{
  bottom: 70px !important;left: 45% !important;
}
   .quizSectionGridClass{
  display:grid;
  grid-template-columns:50% 50%; ;
}
     .hideSmForMock{display: none !important;}
 
    .mockTestTopBarV1{
display:grid;grid-template-columns:auto 17% 17% 5%  35%;
}
.TestInterfaceLeft{
        right:55%;
       }.TestInterfaceRight{
        left:55%;
       }
}

/* xs */
@media (max-width: 767px) {
.instructionQPOuterGridT1{bottom: -4px;transform:scale(0.8)}
     .QPMockPalletInfo{
        display:grid;grid-template-columns: 50% 50% ;
       }
       .palletAllButtonsBoxListQP{display:block !important;}
     .mockQueHintClass{
  bottom: 85px !important;left: 45% !important;
}  .mockQueHintClassTwo{
  bottom: 135px !important;left: 45% !important;
}
  .quizSectionGridClass{
  display:grid;
  grid-template-columns:100%;
}

 .quizSectionAll{width: 140px;
}
.ellipsisTitleQuiz {width:120px;}

.quizSectionAllMore{width: 140px;
}
.quizSectionAllMore .quizSectionAllInnMore{position: absolute !important;top: 60px;left: -95px !important;}
.quizSectionAllMore:hover .quizSectionAllInnMore{visibility: visible;transition:  .5s;top: 45px;z-index: 999999999999 !important;}
.quizSectionMoreItem .quizSectionMoreItemInn{visibility: hidden;transition:  .0s;top: 0px;left: -200px;}
.quizSectionMoreItem:hover .quizSectionMoreItemInn{visibility: visible;transition:  .5s;top: 0px;left: -180px;}
 .quizSectionMoreItemInn::after{ content: "";
    position: absolute;
    left: 105% !important;
    top: 10px;
    margin-right: -6px;
    border-width: 8px;
    border-style: solid;
    border-color:  transparent  transparent   transparent  ${mockTestCard1Object?.sectionAllInner?.border?.borderColor?.color}  ;
}
      .hideXsForMock{display: none !important;}
      .showXsOnlyForMock{display: block !important;}
.mockTestTopBarV1{
display:grid;grid-template-columns:auto 52%;
}.TestInterfaceBottom{height: 80px;
       }
       .TestInterfaceBottomPagenationT1{bottom:95px;
       }
.MockBottomOuter{grid-template-columns:100%;padding-top: 2px;}
.MockBottomInnerRight{justify-content: space-between;align-items: center;gap:5px;margin-bottom: 2px;}
.MockButtonBorder{ width: 100%;}
.MockButtonNext{width: 100%;}
 .TestInterfaceBackDrop{position:fixed;
        top:60px;background:#f1f1f1;opacity:0.8;z-index:99999;
        left:0%;
        right:0%;bottom:80px;
       
       }.TestInterfaceRight{position:fixed;
        top:60px;
        left:10%;
        right:0%;bottom:80px;
        
       }
  .TestInterfaceLeft{position:fixed;z-index:999999;
        top:60px;
        left:0%;
        right:15%;bottom:80px;
       
       }.TestInterfaceRight{position:fixed;
        top:60px;
        left:15%;z-index:999999;
        right:0%;bottom:80px;
        
       }

 }

`}
  


</style></>)
}
export default MockTestStyles;